import { Link } from 'react-router-dom';
import { ApiClientError } from '../../services/api';
import { useMaps } from '../../services/hooks';

export function MapsListPage() {
  const { data, isLoading, isError, error } = useMaps();

  if (isLoading) return <div className="empty">Loading maps…</div>;
  if (isError) {
    const detail =
      error instanceof ApiClientError
        ? `${error.status}: ${error.body.message}`
        : error instanceof Error
          ? error.message
          : 'Unknown error';
    return (
      <div className="empty">
        Unable to load maps. Check that you are signed in and the API is available.
        <div style={{ marginTop: 8, color: 'var(--muted)', fontSize: '0.9rem' }}>{detail}</div>
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', maxWidth: 960, margin: '0 auto' }}>
      <h1>Maps</h1>
      <p style={{ color: 'var(--muted)' }}>Select a map to explore state-level data.</p>
      <div style={{ display: 'grid', gap: 12 }}>
        {(data?.items ?? []).map((m) => (
          <Link
            key={m.mapId}
            to={`/maps/${m.mapId}`}
            className="panel"
            style={{ padding: '1rem 1.25rem', display: 'block' }}
          >
            <strong style={{ fontSize: '1.1rem' }}>{m.name}</strong>
            <div style={{ color: 'var(--muted)', marginTop: 4 }}>{m.description}</div>
          </Link>
        ))}
        {!data?.items.length && <div className="empty">No maps available yet.</div>}
      </div>
    </div>
  );
}
